module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_adwords_call_count-1b5444d7c149b4feafc16a562c233b96.png";